import { createApp } from "vue";
import ModalVue from "../../components/ModalVue";
import CheckoutAddressEditModal from "../../components/CheckoutAddressEditModal";
import i18n from '../translations/i18n';
import BlockCart from "../../components/BlockCart.vue";
import CheckoutPayment from "../../components/CheckoutPayment.vue";
import CheckoutProgress from "../../components/CheckoutProgress.vue";

export const initializeGlobalModalHelpers = () => {
    window.checkoutAddressEdit = (id, countryID, getAddressLink) => {
        return new Promise(resolve => {
            const modalElement = document.createElement('section');
            const app = createApp(CheckoutAddressEditModal, {
                addressId: parseInt(id),
                defaultCountryId: countryID,
                getAddressLink: getAddressLink,
            });

            app.use(i18n);

            modalElement.setAttribute('is-brekz-checkout-address-modal', 'true');
            document.body.appendChild(modalElement);

            app.mount(modalElement);

            resolve(app);
        });
    };

    window.brekzModal = (text, options, buttons) => {
        return new Promise(resolve => {
            const modalElement = document.createElement('section');
            const app = createApp(ModalVue, {
                isMobile: false,
                width: options.width,
                title: text.title,
                show: options.show || false,
                centerButtons: options.centerButtons || false,
                useModalTemplate: options.useModalTemplate || true,
                zIndex: options.zIndex || 3,
                buttons: buttons,
                content: text.content,
                onClose() {
                    modalElement.remove();
                }
            });

            modalElement.setAttribute('is-brekz-modal', 'true');
            document.body.appendChild(modalElement);

            app.mount(modalElement);

            resolve(app);
        });
    };
};

export const initializeGlobalBlockCart = () => {
    if (! document.getElementById('js_blockcart')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('block-cart', BlockCart);

    app.mount('#js_blockcart');
}

export const initializePriceDisplayExplanationModal = () => {
    if (! document.getElementById('js_priceDisplayExplanation')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('modal-vue', ModalVue);

    app.mount('#js_priceDisplayExplanation');
}
